<template>
  <div id="commandment-file" ref="contract"
       style="line-height: 2; width: 100%">
    <section slot="pdf-content" contenteditable="true">
      <div class="col-md-12">
        <div class="info-block">
          <div style="text-align: center; font-weight: 700">ԱՆԺԱՄԿԵՏ ՏԵՆԴԵՐՆԵՐԻ ՄԻՋՈՑՈՎ ԱՊՐԱՆՔՆԵՐԻ ԳՆՄԱՆ ՊԱՅՄԱՆԱԳԻՐ
          </div>
          <div style="text-align: center; font-weight: 700">N<span class="contract-code"
                                                                   style="color: rgb(17, 85, 204);"> {{
              tenderData.code
            }}</span></div>
          <br>
          <table style="width: 100%; border: none !important">
            <tbody>
            <tr>
              <td style="border:none !important;" class="ft-11">
                <div style="padding: 0 !important; text-align: left">
                  <h6><span style="color: rgb(17, 85, 204);">{{ buyer.city }}</span></h6>
                </div>
              </td>
              <td style="border:none !important;" class="ft-11">
                <div style="padding: 0 !important; text-align: right">
                  <h6><span style="color: rgb(17, 85, 204);" class="sign-date">{{ contractDate }}</span>թ.</h6>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <br>
        </div>
        <br />
        <div style="font-weight: 700; text-align: center;">1. ԱՌԱՐԿԱՆ</div>
        <br>
        <div class="info-block">
          <div style="text-align: justify;">
            <span style="margin: 0 25px;">1.1.</span>Հաղթող մասնակիցը /այսուհետև՝ Վաճառող/ պարտավորվում է Կազմակերպիչին
            /այսուհետև՝ Գնորդ/ մատակարարել անժամկետ տենդերի պայմաններով սահմանված գնման առարկայի բնութագրերով նախատեսված
            ապրանք /այսուհետ` Ապրանք/:<br />
            <span style="margin: 0 25px;">1.2.</span>Գնորդը պարտավորվում է ընդունել այդ Ապրանքը և վճարել դրա համար
            անժամկետ տենդերի պայմաններով և սույն պայմանագրով սահմանված ժամկետներում։
          </div>
        </div>
        <br />
        <div style="font-weight: 700; text-align: center;">2. ՄԱՏԱԿԱՐԱՐՈՒՄԸ</div>
        <br>
        <div class="info-block">
          <div style="text-align: justify;">
            <span style="margin: 0 25px;">2.1.</span>Ապրանքների տեղափոխումը իրականացնում է Վաճառողը անժամկետ տեդներների
            պայմաններով և սույն պայմանագրով սահմանված կարգով:<br />
            <span style="margin: 0 25px;">2.2.</span>Վաճառողը պարտավորվում է ապրանքը մատակարարել սույն Պայմանագրի Հավելված 1-ում սահմանված Գնման պայմաններով և Գնորդի կողմից նախանշված հասցեում հանձնելու միջոցով։<br />
            <span style="margin: 0 25px;">2.3.</span>Ապրանքի կամ դրա մի մասի մատակարարման օր է համարվում Ապրանքի
            հանձնման-ընդունման փաստը հաստատող երկկողմ փաստաթղթի կազմման օրը։
          </div>
        </div>
        <br />
        <div style="font-weight: 700; text-align: center;">3. ԿՈՂՄԵՐԻ ԻՐԱՎՈՒՆՔՆԵՐԸ ԵՎ ՊԱՐՏԱԿԱՆՈՒԹՅՈՒՆՆԵՐԸ</div>
        <br>
        <div class="info-block">
          <div style="text-align: justify;">
            <span style="font-weight: 700"><span style="margin: 0 25px;">3.1.</span>Գնորդն իրավունք ունի`</span><br />
            <span style="margin: 0 25px;">3.1.1.</span>Սահմանված ժամկետում Վաճառողի կողմից Ապրանքը չմատակարարելու կամ
            անպատշաճ որակի` նշված տեխնիկական բնութագրին չհամապատասխանող Ապրանք մատակարարելու կամ որոշվածից պակաս քանակի
            Ապրանք մատակարարելու կամ որոշված տեսակի պայմանի խախտմամբ Ապրանք մատակարարելու դեպքերում իր հայեցողությամբ
            սահմանել համապատասխան որակի, տեսակի և քանակի Ապրանքով անհատույց փոխարինման ողջամիտ ժամկետ և պահանջել
            Վաճառողից վճարելու սույն պայմանագրի 7.2 կետով նախատեսված տույժը կամ հրաժարվել Ապրանքից<br />
            <span style="margin: 0 25px;">3.1.2.</span>Միակողմանի լուծել սույն պայմանագիրը (լրիվ կամ մասնակի),
            եթե Վաճառողի կողմից Ապրանքի մատակարարման ժամկետները խախտվել են 2 օրից ավելի.<br />
            <span style="margin: 0 25px;">3.1.3.</span>Զննել Ապրանքը և հայտնաբերված թերությունների մասին անհապաղ
            տեղեկացնել Վաճառողին։<br />
            <span style="font-weight: 700"><span style="margin: 0 25px;">3.2.</span>Գնորդը պարտավոր է`</span><br />
            <span style="margin: 0 25px;">3.2.1.</span>Կատարել համապատասխան մատակարարված Ապրանքի ընդունումն ապահովող
            բոլոր անհրաժեշտ գործողությունները։<br />
            <span style="margin: 0 25px;">3.2.2.</span>Վաճառողի կողմից հանձնած Ապրանքից հրաժարվելու դեպքում, ապահովել
            այդ Ապրանքի պատասխանատու պահպանությունը և դրա մասին անհապաղ տեղեկացնել Վաճառողին.<br />
            <span style="margin: 0 25px;">3.2.3.</span>Նախատեսված կարգով և ժամկետներում մատակարարված Ապրանքն ընդունելու
            դեպքում Վաճառողին վճարել վերջինիս վճարման ենթակա գումարները, իսկ վճարման ժամկետի խախտման դեպքում` նաև 7.4
            կետով նախատեսված տույժը։<br />
            <span style="margin: 0 25px;">3.2.4.</span>Ապրանքի քանակի, տեսականու, որակի մասին մատակարարման պայմանները
            խախտելու մասին Վաճառողին ծանուցել թերությունը հայտնաբերելուց հետո անմիջապես կամ այն բանից հետո` ողջամիտ
            ժամկետում, երբ համապատասխան պայմանի խախտումը պետք է հայտնաբերված լիներ` ելնելով Ապրանքի բնույթից և
            նշանակությունից։<br />
            <span style="margin: 0 25px;">3.2.5.</span>3.3.4 կետի համաձայն սույն պայմանագիրը միակողմանի լուծելուց
            հետո Վաճառողին հատուցել վերջինիս վնասները։<br />
            <span style="font-weight: 700"><span style="margin: 0 25px;">3.3.</span>Վաճառողն իրավունք ունի`</span><br />
            <span style="margin: 0 25px;">3.3.1.</span>Գնորդից պահանջել ընդունելու նախատեսված կարգով, որակով, տեսակով,
            քանակով և ժամկետներում մատակարարված Ապրանքը.<br />
            <span style="margin: 0 25px;">3.3.2.</span>Գնորդից պահանջել վճարելու նախատեսված կարգով, որակով, տեսակով,
            քանակով և ժամկետներում մատակարարված Ապրանքի համար իրեն վճարման ենթակա գումարները.<br />
            <span style="margin: 0 25px;">3.3.3.</span>Միակողմանի լուծել սույն պայմանագիրը (լրիվ կամ մասնակի),
            եթե Գնորդի կողմից խախտվել են Ապրանքի համար վճարելու ժամկետները։<br />
            <span style="margin: 0 25px;">3.2.1.</span>Գնորդի համաձայնությամբ վաղաժամկետ մատակարարել Ապրանքը։<br />
            <span style="font-weight: 700"><span style="margin: 0 25px;">3.4.</span>Վաճառողը պարտավոր է`</span><br />
            <span style="margin: 0 25px;">3.4.1.</span>Գնորդին հանձնել Ապրանքը` նախատեսված կարգով, որակով, տեսակով,
            քանակով և գնման ժամանակացուցով սահմանված ժամկետներում, իսկ Գնորդի պահանջով տրամադրել Ապրանքի որակը հավաստող
            փաստաթղթեր։<br />
            <span style="margin: 0 25px;">3.4.2.</span>Գնորդին հանձնել երրորդ անձանց իրավունքներից ազատ Ապրանք։<br />
            <span style="margin: 0 25px;">3.4.3.</span>Թերի մատակարարում թույլ տալու դեպքում, նախատեսված կարգով, լրացնել
            թերի մատակարարվածը։<br />
            <span style="margin: 0 25px;">3.4.4.</span>Նախատեսված դեպքերում վճարել սույն պայմանագրի 7.2 կետով նախատեսված
            տույժը։<br />
            <span style="margin: 0 25px;">3.4.5.</span>Գնորդին հանձնել Ապրանքի պատկանելիքները և համապատասխան
            փաստաթղթերը։<br />
            <span style="margin: 0 25px;">3.4.6.</span>3.1.2 կետի համաձայն միակողմանի լուծվելուց հետո Գնորդին հատուցել
            վերջինիս վնասները։<br />
            <span style="margin: 0 25px;">3.4.7.</span>մինչև սույն պայմանագրի կատարումը ծագած հիմքով երրորդ անձանց կողմից
            Ապրանքն առգրավելու դեպքում հատուցել Գնորդի վնասները.<br />
          </div>
        </div>
        <br />
        <div style="font-weight: 700; text-align: center;">4. ԱՊՐԱՆՔԻ ԳԻՆԸ ԵՎ ՎՃԱՐՄԱՆ ԿԱՐԳԸ</div>
        <br>
        <div class="info-block">
          <div style="text-align: justify;">
            <span style="margin: 0 25px;">4.1.</span>Ապրանքի գինը դա անժամկետ տենդերի հաղթած գինն է՝
            {{ totalAmount }}
            <template v-if="totalAmountWord">/{{ totalAmountWord }}/</template>
            ՀՀ դրամ
            <template v-if="isWithVat">՝ ներառյալ ԱԱՀ</template>
            , որը ներառում է հարկերը, տուրքերը և ՀՀ օրենսդրությամբ սահմանված այլ վճարները, ինչպես նաև Վաճառողի կողմից
            իրականացվող բոլոր ծախսերը, այդ թվում՝ Ապրանքը Գնորդին հասնցելու համար նախատեսված բոլոր ծախսերը։ Գնի մեջ ներառված չէ միայն Վաճառողի կողմից նախապես առանձին ներկայացված Ապրանքի առաքման գումարը։<br />
            <span style="margin: 0 25px;">4.2.</span>Գնորդն իրեն մատակարարվելիք Ապրանքի դիմաց վճարում է ՀՀ դրամով,
            անկանխիկ` դրամական միջոցները Վաճառողի հաշվարկային հաշվին փոխանցելու միջոցով։ Դրամական միջոցների վճարումը կամ
            փոխանցումը կատարվում է անժամկետ տենդերի պայմաններով սահմանված ժամկետներում:<br />
          </div>
        </div>
        <br />
        <div style="font-weight: 700; text-align: center;">5. ԱՊՐԱՆՔԻ ՈՐԱԿԸ</div>
        <br>
        <div class="info-block">
          <div style="text-align: justify;">
            <span style="margin: 0 25px;">5.1.</span>Վաճառողը երաշխավորում է մատակարարված Ապրանքի որակի
            համապատասխանությունը գործող ստանդարտների պահանջներին։<br />
          </div>
        </div>
        <br />
        <div style="font-weight: 700; text-align: center;">6. ԱՊՐԱՆՔԻ ՀԱՆՁՆՈՒՄԸ ԵՎ ԸՆԴՈՒՆՈՒՄԸ</div>
        <br>
        <div class="info-block">
          <div style="text-align: justify;">
            <span style="margin: 0 25px;">6.1.</span>Վաճառողն Ապրանքը հանձնում է Գնորդին` սույն պայմանագրի Հավելված 1-ում նշված մատակարարման հասցեով, ծավալներով և
            ժամկետներում։<br />
            <span style="margin: 0 25px;">6.2.</span>Ապրանքը Գնորդի կողմից ընդունված է համարվում համապատասխան
            հաշվապահական և/կամ իրավական փաստաթղթերի երկկողմանի հաստատելու պահից։<br />
          </div>
        </div>
        <br />
        <div style="font-weight: 700; text-align: center;">7. ԿՈՂՄԵՐԻ ՊԱՏԱՍԽԱՆԱՏՎՈՒԹՅՈՒՆԸ</div>
        <br>
        <div class="info-block">
          <div style="text-align: justify;">
            <span style="margin: 0 25px;">7.1.</span>Վաճառողը պատասխանատվություն է կրում հանձնած Ապրանքի որակի, տեսակի,
            քանակի և նախատեսված մատակարարման ժամկետների պահպանման համար։<br />
            <span style="margin: 0 25px;">7.2.</span>Վաճառողի կողմից նախատեսված Ապրանքի մատակարարման ժամկետների խախտման
            դեպքում Վաճառողից յուրաքանչյուր ուշացված օրվա համար գանձվում է տույժ` մատակարարման ենթակա, սակայն
            չմատակարարված Ապրանքի գնի 0,05 (զրո ամբողջ հինգ հարյուրերրորդական) տոկոսի չափով։<br />
            <span style="margin: 0 25px;">7.3.</span>7.2 կետով նախատեսված տույժը հաշվարկվում և հաշվանցվում են Վաճառողին
            վճարման ենթակա գումարների հետ։<br />
            <span style="margin: 0 25px;">7.4.</span>Գնորդի կողմից 4.2 կետով նախատեսված ժամկետի խախտման համար գնորդի
            նկատմամբ յուրաքանչյուր ուշացված օրվա համար հաշվարկվում է տույժ` վճարման ենթակա, սակայն չվճարված գումարի 0,05
            (զրո ամբողջ հինգ հարյուրերրորդական) տոկոսի չափով։<br />
            <span style="margin: 0 25px;">7.5.</span>Սույն պայմանագրով չնախատեսված դեպքերում կողմերն իրենց
            պարտավորությունները չկատարելու կամ ոչ պատշաճ կատարելու համար պատասխանատվություն են կրում ՀՀ օրենսդրությամբ
            սահմանված կարգով։<br />
            <span style="margin: 0 25px;">7.6.</span>Տույժերի վճարումը կողմերին չի ազատում իրենց պարտվորությունները լրիվ
            կատարելուց։<br />
          </div>
        </div>
        <br />
        <div style="font-weight: 700; text-align: center;">8. ԱՆՀԱՂԹԱՀԱՐԵԼԻ ՈՒԺԻ ԱԶԴԵՑՈՒԹՅՈՒՆԸ /ՖՈՐՍ-ՄԱԺՈՐ</div>
        <br>
        <div class="info-block">
          <div style="text-align: justify;">
            <span style="margin: 0 25px;">8.1.</span>Պարտավորություններն ամբողջությամբ կամ մասնակիորեն չկատարելու համար
            կողմերն ազատվում են պատասխանատվությունից, եթե դա եղել է անհաղթահարելի ուժի ազդեցության հետևանքով, որը
            կողմերը չէին կարող կանխատեսել կամ կանխարգելել։ Այդպիսի իրավիճակներ են երկրաշարժը, ջրհեղեղը, հրդեհը,
            պատերազմը, ռազմական և արտակարգ դրություն հայտարարելը, քաղաքական հուզումները, գործադուլները, հաղորդակցության
            միջոցների աշխատանքի դադարեցումը, պետական մարմինների ակտերը և այլն, որոնք անհնարին են դարձնում
            պարտավորությունների կատարումը։ Եթե արտակարգ ուժի ազդեցությունը շարունակվում է 3 (երեք) ամսից ավելի, ապա
            կողմերից յուրաքանչյուրն իրավունք ունի լուծել սույն պայմանագիրը` այդ մասին նախապես տեղյակ պահելով մյուս
            կողմին։<br />
            <span style="margin: 0 25px;">8.2.</span>Անհաղթահարելի ուժի ազդեցության հետևանքով պայմանագրային
            պարտավորությունները չկատարող Կողմը պարտավոր է ողջամիտ ժամկետում մյուս Կողմին տեղյակ պահել անհաղթահարելի ուժի
            առկայության և պարտավորությունները չկատարելու մասին:<br />
          </div>
          <br />
          <div style="font-weight: 700; text-align: center;">9. ԱՅԼ ՊԱՅՄԱՆՆԵՐ</div>
          <br>
          <div class="info-block">
            <div style="text-align: justify;">
              <span style="margin: 0 25px;">9.1.</span>Մատակարարումներից ծագած` կողմի վճարային պարտավորությունը չի կարող
              դադարել այլ պայմանագրից ծագած` հակընդդեմ պարտավորության հաշվանցով, առանց կողմերի գրավոր և կնիքով հաստատված
              համաձայնության։ Սույն մատակարարման պայմաններից ծագած պահանջի իրավունքը չի կարող փոխանցվել այլ անձի, առանց
              պարտապան կողմի գրավոր համաձայնության։<br />
              <span style="margin: 0 25px;">9.2.</span>Սույն գործարքի հետ կապված վեճերը ենթակա են քննության Հայաստանի
              Հանրապետության դատարաններում։<br />
              <span style="margin: 0 25px;">9.3.</span>Մատակարարումների և վճարումների պատշաճ կատարման պայմաններում
              կողմերի (Վաճառող և (կամ) Գնորդ) օգուտները (խնայողություններ) և (կամ) կրած վնասները տվյալ կողմի օգուտը կամ
              կրած վնասն են։<br />
              <span style="margin: 0 25px;">9.4.</span>Կողմերի` երրորդ անձանց նկատմամբ պարտավորությունները՝ ներառյալ
              մատակարարումների իրականացման շրջանակում Վաճառողի կնքած այլ գործարքները և դրանցից բխող պարտավորությունները,
              չեն կարող ազդել մատակարարման վրա։ Այդ գործարքների և դրանցից բխող պարտավորությունների կատարման հետ կապված
              հարաբերությունները կարգավորվում են այդ գործարքների հետ կապված հարաբերությունները կարգավորող նորմերով, և
              դրանց համար պատասխանատու է Վաճառողը։<br />
              <span style="margin: 0 25px;">9.5.</span>Մատակարարման պայմանների հետ կապված վեճերը լուծվում են
              բանակցությունների միջոցով։ Համաձայնություն ձեռք չբերելու դեպքում վեճերը լուծվում են դատական կարգով։<br />
              <span style="margin: 0 25px;">9.6.</span>Գնորդի և Վաճառողի միջև ծագած իրավահարաբերությունների նկատմամբ
              կիրառվում է Հայաստանի Հանրապետության օրնեքը։<br />
              <span style="margin: 0 25px;">9.7.</span>Պայմանագիրն ուժի մեջ է մտնում այն ստորագրելու պահից և գործում է
              մինչև կողմերի պարտավորությունների ամբողջական կատարումը։<br />
              <span style="margin: 0 25px;">9.8.</span>Պայմանագրում կատարվող փոփոխություններն ու լրացումները կողմերը
              ձևակերպում են լրացուցիչ համաձայնագրով, որը Պայմանագրի անբաժանելի մասն է։<br />
              <span style="margin: 0 25px;">9.9.</span>Պայմանագիրը կազմված է հայերեն լեզվով, 2 օրինակից, որոնք ունեն
              հավասարազոր իրավաբանական ուժ։<br />
            </div>
          </div>
        </div>
        <br />
        <div class="html2pdf__page-break" />
        <div class="info-block">
          <br>
          <div style="text-align: center; font-weight: 700">
            10. ԿՈՂՄԵՐԻ ՀԱՍՑԵՆԵՐԸ, ԲԱՆԿԱՅԻՆ ՎԱՎԵՐԱՊԱՅՄԱՆՆԵՐԸ և ՍՏՈՐԱԳՐՈՒԹՅՈՒՆՆԵՐԸ
          </div>
          <br>
          <div>
            <table class="ft-5" style="table-layout: fixed;margin-top:50px; width: 100%; border: none !important">
              <tbody>
              <tr>
                <td style="border:none !important; width: 50%; text-align: center; padding-right: 10px;">
                  <h6 class="ft-11" style="font-weight: 700">ԳՆՈՐԴ</h6>
                  <p class="ft-11">{{ buyer.name }}</p>
                  <p class="ft-11">Հասցե՝ {{ buyer.address }}</p>
                  <p class="ft-11">Բանկ՝ {{ buyer.bank }}</p>
                  <p class="ft-11">Հ/Հ` {{ buyer.bankAccount }}</p>
                  <p class="ft-11">ՀՎՀՀ` {{ buyer.tin }}</p>
                  <p class="ft-11">Հեռախոսահամար՝ {{ buyer.phone }}</p>
                  <p class="ft-11">Տնօրեն՝ {{ buyer.directorName }}</p>
                  <p class="ft-11">
                    <b v-if="buyer.sign">
                      <i>Ստորագրված է {{ buyer.sign_date }}</i>
                    </b>
                    <span v-else>______________________</span>
                  </p>
                  <p>էլ․ ստորագրություն</p>
                </td>
                <td style="border:none !important;padding-left: 10px; text-align: center; width: 50%;">
                  <h6 class="ft-11" style="font-weight: 700">ՎԱՃԱՌՈՂ</h6>
                  <p class="ft-11">{{ seller.name }}</p>
                  <p class="ft-11">Հասցե՝ {{ seller.address }}</p>
                  <p class="ft-11">Բանկ՝ {{ seller.bank }}</p>
                  <p class="ft-11">Հ/Հ` {{ seller.bankAccount }}</p>
                  <p class="ft-11">ՀՎՀՀ` {{ seller.tin }}</p>
                  <p class="ft-11">Հեռախոսահամար՝ {{ seller.phone }}</p>
                  <p class="ft-11">Տնօրեն՝ {{ seller.directorName }}</p>
                  <p class="ft-11">
                    <b v-if="seller.sign">
                      <i>Ստորագրված է {{ seller.sign_date }}</i>
                    </b>
                    <span v-else>______________________</span>
                  </p>
                  <p>էլ․ ստորագրություն</p>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <span style="text-align: left; font-style: italic; font-size: 10px; margin-bottom: 3rem">
            Անհրաժեշտության դեպքում պայմանագրում կարող են ներառվել ՀՀ օրենսդրությանը և «Անժամկետ տենդերներ» կանոնակարգին չհակասող դրույթներ։
          </span>
        </div>
        <div class="html2pdf__page-break" />
        <pagebreak />
        <br class="page-break" />
        <div class="info-block">
          <div style="text-align: right; margin-top: 3rem">Հավելված N 1</div>
          <div style="text-align: right">Անժամկետ տենդերների միջոցով ապրանքների</div>
          <div style="text-align: right">գնման N {{ tenderData.code }} պայմանագրի</div>
          <br />
          <div style="text-align: center; font-weight: 700">Ապրանքի գնման և վճարման պայմաններ</div>
          <table style="font-size: 10px;
                                width: 100%;
                                table-layout: fixed;
                                border-collapse: collapse;
                                page-break-inside: avoid;
                                border: 1px solid black;
                                text-align: center;" class="ft-5">
            <thead>
            <tr>
              <td style="border: 1px solid black;
                                                        border-collapse: collapse;
                                                        text-align: center;">Ապրանքի անվանում
              </td>
              <td style=" border: 1px solid black;
                                                        border-collapse: collapse;
                                                        text-align: center;">Տեխնիկական բնութագիր
              </td>
              <td style="border: 1px solid black;
                                                       border-collapse: collapse;
                                                       text-align: center;">Չափման միավոր
              </td>
              <td style="border: 1px solid black;
                                                       border-collapse: collapse;
                                                       text-align: center;">Քանակ
              </td>
              <td style="border: 1px solid black;
                                                       border-collapse: collapse;
                                                       text-align: center;">Գնման պայմաններ
              </td>
              <td style="border: 1px solid black;
                                                       border-collapse: collapse;
                                                       text-align: center;">Մատակարարման պայմաններ
              </td>
              <td style="border: 1px solid black;
                                                       border-collapse: collapse;
                                                       text-align: center;">Առաքման պայմաններ
              </td>
              <td style="border: 1px solid black;
                                                       border-collapse: collapse;
                                                       text-align: center;">Վճարման պայմաններ
              </td>
              <td style="border: 1px solid black;
                                                       border-collapse: collapse;
                                                       text-align: center;">Մատակարարման հասցեն
              </td>
            </tr>

            </thead>
            <tbody id="products-table-body" >
            <tr v-for="(row, rowIndex) in tenderData.rows" :key="rowIndex">
              <td style="border: 1px solid black;
                                           border-collapse: collapse;
                                           text-align: center;">{{ row.name }}
              </td>
              <td style="border: 1px solid black;
                                           border-collapse: collapse;
                                           text-align: center;">{{ row.specification }}
              </td>
              <td style="border: 1px solid black;
                                           border-collapse: collapse;
                                           text-align: center;">{{ row.unit }}
              </td>
              <td style="border: 1px solid black;
                                           border-collapse: collapse;
                                           text-align: center;">{{ row.count }}
              </td>
              <td style="border: 1px solid black;
                                           border-collapse: collapse;
                                           text-align: center;">{{ row.terms_of_purchase }}
              </td>
              <td style="border: 1px solid black;
                                           border-collapse: collapse;
                                           text-align: center;">{{ row.delivery_terms }}
              </td>
              <td style="border: 1px solid black;
                                           border-collapse: collapse;
                                           text-align: center;">{{ row.offer_delivery_terms }}
              </td>
              <td style="border: 1px solid black;
                                           border-collapse: collapse;
                                           text-align: center;">{{ row.payment_terms }}
              </td>
              <td style="border: 1px solid black;
                                           border-collapse: collapse;
                                           text-align: center;">{{ row.delivery_address }}
              </td>
            </tr>
            </tbody>
          </table>
          <div>
            <table style="table-layout: fixed;margin-top:50px; width: 100%; border: none !important">
              <tbody>
              <tr>
                <td style="border:none !important; width: 50%; text-align: center; padding-right: 10px;">
                  <h6 class="ft-11" style="font-weight: 700">ԳՆՈՐԴ</h6>
                  <p class="ft-11">{{ buyer.name }}</p>
                  <p class="ft-11">Հասցե՝ {{ buyer.address }}</p>
                  <p class="ft-11">Բանկ՝ {{ buyer.bank }}</p>
                  <p class="ft-11">Հ/Հ` {{ buyer.bankAccount }}</p>
                  <p class="ft-11">ՀՎՀՀ` {{ buyer.tin }}</p>
                  <p class="ft-11">Հեռախոսահամար՝ {{ buyer.phone }}</p>
                  <p class="ft-11">Տնօրեն՝ {{ buyer.directorName }}</p>
                  <p class="ft-11">
                    <b v-if="buyer.sign">
                      <i>Ստորագրված է {{ buyer.sign_date }}</i>
                    </b>
                    <span v-else>______________________</span>
                  </p>
                  <p>էլ․ ստորագրություն</p>
                  <p v-if="buyer.phone" class="ft-11">Հեռախոսահամար՝ {{ buyer.phone }}</p>
                </td>
                <td style="border:none !important;padding-left: 10px; text-align: center; width: 50%;">
                  <h6 class="ft-11" style="font-weight: 700">ՎԱՃԱՌՈՂ</h6>
                  <p class="ft-11">{{ seller.name }}</p>
                  <p class="ft-11">Հասցե՝ {{ seller.address }}</p>
                  <p class="ft-11">Բանկ՝ {{ seller.bank }}</p>
                  <p class="ft-11">Հ/Հ` {{ seller.bankAccount }}</p>
                  <p class="ft-11">ՀՎՀՀ` {{ seller.tin }}</p>
                  <p class="ft-11">Հեռախոսահամար՝ {{ seller.phone }}</p>
                  <p class="ft-11">Տնօրեն՝ {{ seller.directorName }}</p>
                  <p class="ft-11">
                    <b v-if="seller.sign">
                      <i>Ստորագրված է {{ seller.sign_date }}</i>
                    </b>
                    <span v-else>______________________</span>
                  </p>
                  <p>էլ․ ստորագրություն</p>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import purchaseTypesLongNamesCased from '@/mixins/purchaseTypes'

export default {
  name: 'contract_draft_product',
  mixins: [purchaseTypesLongNamesCased],
  props: ['handleLoaded', 'tender', 'order'],
  emits: ['handleIsFullySigned'],
  data() {
    return {
      deliverAddress: this.order?.delivery_address,
      totalAmount: this.order?.total_amount,
      totalAmountWord: '',
      isWithVat: false,
      tenderData: {},
      buyer: {},
      seller: {},
      contractDate: this.currentDate(),
    }
  },
  async mounted() {
    this.handleLoaded()
    if (this.order?.order_id) {
      this.$client.get(`timeless-tenders/getContractData/${this.order.order_id}`).then(async ({ data }) => {
        if (data.confirm_date) {
          this.contractDate = data.confirm_date
        }
        this.isWithVat = data.offer_details.is_with_vat
        this.buyer = {
          name: `«${data.buyer.organisation.name.hy}» ${data.buyer.organisation.company_type.hy}`,
          address: `${data.buyer.organisation.region.hy} ${data.buyer.organisation.city.hy} ${data.buyer.organisation.address.hy}`,
          bank: data.buyer.organisation.bank_name.hy,
          bankAccount: data.buyer.organisation.bank_account,
          tin: data.buyer.organisation.tin,
          directorName: data.buyer.organisation.director_name.hy,
          city: data.buyer.organisation.city.hy,
          sign: data.buyer_sign,
          sign_date: data.buyer_sign_date,
          phone: data.buyer.phone,
        }
        if ((data.buyer_sign && data.seller_sign) || (this.me.email === data.seller.email)) {
          console.log('HAVE SELLER INFO');
          this.seller = {
            name: `«${data.seller.organisation.name.hy}» ${data.seller.organisation.company_type.hy}`,
            address: `${data.seller.organisation.region.hy} ${data.seller.organisation.city.hy} ${data.seller.organisation.address.hy}`,
            bank: data.seller.organisation.bank_name.hy,
            bankAccount: data.seller.organisation.bank_account,
            tin: data.seller.organisation.tin,
            directorName: data.seller.organisation.director_name.hy,
            sign: data.seller_sign,
            sign_date: data.seller_sign_date,
            phone: data.seller.phone,
          }
          if(data.buyer_sign && data.seller_sign){
            this.$emit('handleIsFullySigned')
          }
        } else {
          console.log('DONT SELLER INFO');
          this.seller = {
            name: `«________________» ___`,
            address: '_________________________',
            bank: '_________________________',
            bankAccount: '_________________________',
            tin: '_________________________',
            directorName: '_________________________',
            phone: '_____________',
          }
        }
        this.tenderData = {
          code: data.tender.code,
          rows: [
            {
              name: data.tender.name,
              specification: data.tender.specification,
              unit: data.tender.unit,
              count: data.count,
              terms_of_purchase: data.tender.terms_of_purchase,
              delivery_terms: data.tender.delivery_terms,
              offer_delivery_terms: data.offer_details.delivery_terms,
              payment_terms: data.tender.payment_terms,
              delivery_address: this.order?.delivery_address,
            },
          ],
        }
        this.totalAmountWord = await this.numberToWord(data.total_amount)
        console.log(this.tenderData)
      }).catch((error) => {
        console.log(error)
      })
    } else {
      this.tenderData = this.tender
      this.totalAmount = this.tenderData.totalAmount
      this.isWithVat = this.tenderData.isWithVat
      this.buyer = {
        name: `«${this.me.organisation[0].translations.name.hy}» ${this.me.organisation[0].translations.company_type.hy}`,
        address: `${this.me.organisation[0].translations.region.hy} ${this.me.organisation[0].translations.city.hy} ${this.me.organisation[0].translations.address.hy}`,
        bank: this.me.organisation[0].translations.bank_name.hy,
        bankAccount: this.me.organisation[0].bank_account,
        tin: this.me.organisation[0].tin,
        directorName: this.me.organisation[0].translations.director_name.hy,
        city: this.me.organisation[0].translations.city.hy,
        phone: this.me.organisation[0].phone,
      }
      this.seller = {
        name: `«________________» ___`,
        address: '_________________________',
        bank: '_________________________',
        bankAccount: '_________________________',
        tin: '_________________________',
        directorName: '_________________________',
        phone: '_____________',
      }
      this.totalAmountWord = await this.numberToWord(this.tenderData.totalAmount)
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  watch: {},
  methods: {
    currentDate() {
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var mm = String(today.getMonth() + 1).padStart(2, '0')
      var yyyy = today.getFullYear()
      return mm + '.' + dd + '.' + yyyy

    },
    consoleLog(msg) {
      console.log(msg)
    },
    calculateMonthPrice(price, percent) {
      return price * percent / 100
    },
    async numberToWord(number) {
      const { data } = await this.$client.post('numberToWord', { number })
      console.log(data)
      if (typeof data === 'string') {
        return data
      } else {
        return ''
      }
    },
  },
}
</script>
<style>
.sign {
  font-size: 8px;
}

.option-box * {
  color: grey;
}

.option-box-selected * {
  color: red;
}
</style>
<style scoped>
* {
  font-family: GHEA grapalat !important;
}
</style>
